import React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

export interface ContestStartMetaProps {
  /** Countdown, relative time, LIVE, Complete, etc. */
  value: React.ReactNode;
  /** Number of questions / picks in the contest */
  picksCount?: number;
  className?: string;
  /** Overrides default `text-primary` on the start value (e.g. live → success green) */
  valueClassName?: string;
  startLabel?: string;
  picksLabel?: string;
}

/**
 * Contest start + picks line — Figma 10203:49907 / Time 10011:8695
 * "Start:" muted · value brand red · "nº picks:" muted · count white
 */
export function ContestStartMeta({
  value,
  picksCount,
  className,
  valueClassName,
  startLabel,
  picksLabel,
}: ContestStartMetaProps) {
  const { t } = useTranslation();
  const resolvedStartLabel = startLabel ?? t('game.labels.start');
  const resolvedPicksLabel = picksLabel ?? t('game.labels.numPicks');
  return (
    <div
      className={cn(
        'flex flex-wrap items-center gap-x-4 gap-y-2 font-sans text-label-sm capitalize',
        className
      )}
    >
      <div className="flex items-center gap-2 whitespace-nowrap">
        <span className="text-muted-foreground font-normal">{resolvedStartLabel}</span>
        <span className={cn('font-semibold text-primary', valueClassName)}>{value}</span>
      </div>
      {picksCount !== undefined ? (
        <div className="flex items-center gap-2 whitespace-nowrap">
          <span className="text-muted-foreground font-normal">{resolvedPicksLabel}</span>
          <span className="font-semibold text-white">{picksCount}</span>
        </div>
      ) : null}
    </div>
  );
}
